import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import html2pdf from "html2pdf.js";
import {
  orderDetails,
} from "../../../controllers/V1/promocodes/promocodeController";
import { getPublicContent } from "../../../controllers/V1/raffleCoupon/raffleCouponContentController";
import Loading from "../../../components/Loading/LoadingEffect";
import BuyWinCouponCard, {
  pageStyle,
} from "../raffleCoupon/BuyWinCouponCard";
import { DEFAULT_COUPON_CONTENT, mergeCouponContent } from "../raffleCoupon/couponContentDefaults";

const DownloadOrder = () => {
  const printRef = useRef();
  const params = useParams();
  const ORDER_ID = params?.order_id;
  const [orderData, setOrderData] = useState({});
  const [drawData, setDrawData] = useState({});
  const [couponContent, setCouponContent] = useState(DEFAULT_COUPON_CONTENT);
  const [isLoading, setLoading] = useState(false);

  const generatePdf = async () => {
    try {
      const element = printRef.current;
      const options = {
        margin      : .25,
        filename    : `Order - ${moment(new Date()).format('DD-MM-YYYY')}.pdf`,
        image       : { type: "jpeg", quality: 1 },
        html2canvas : { dpi: 1200, letterRendering: true, scale: 3 },
        jsPDF       : { unit: "in", format: [8.5, 11], orientation: "portrait" }
      };
      await html2pdf().from(element).set(options).save();
    } finally {
        
    }
  };

  const getOrderDetails = async () => {
    try {
      setLoading(true);
      const res = await orderDetails(ORDER_ID);
      if(res.status === true){
        setOrderData(res?.result?.orderData || {}); 
        setDrawData(res?.result?.drawData || {});
      }
    } catch (error) {
      setLoading(false);
    } finally{
      generatePdf();
      setLoading(false);
    }
  }

  useEffect(()=>{
    getOrderDetails();
  },[]);

  useEffect(() => {
    const fetchCouponContent = async () => {
      const res = await getPublicContent();
      if (res.status === true && res.result) {
        setCouponContent(mergeCouponContent(res.result));
      }
    };
    fetchCouponContent();
  }, []);

  const name = [orderData?.buyer_first_name, orderData?.buyer_last_name]
    .filter(Boolean)
    .join(" ");
  const cpr = orderData?.cpr_number || "N/A";
  const order_no = orderData?.order_no || "N/A";
  const mob = orderData?.buyer_user_id?.country_code
    ? `${orderData.buyer_user_id.country_code} ${orderData.buyer_mobile || ""}`.trim()
    : orderData?.buyer_mobile || "";
  const raffleCoupon = orderData?.coupon_code || "";
  const drawDateFormatted =
    orderData?.draw_date && orderData.draw_date !== "N/A"
      ? moment(`${orderData.draw_date} ${orderData.draw_time || "00:00"}:00`).format("DD-MM-YYYY hh:mm A")
      : "N/A";
  const promotionFrom = drawData?.from_date
    ? moment(drawData.from_date).format("DD-MM-YYYY")
    : orderData?.promocode_data?.valid_date
      ? moment(orderData.promocode_data.valid_date).format("DD-MM-YYYY")
      : "";
  const promotionTo = drawData?.to_date
    ? moment(drawData.to_date).format("DD-MM-YYYY")
    : orderData?.promocode_data?.expire_date
      ? moment(orderData.promocode_data.expire_date).format("DD-MM-YYYY")
      : "";

  return (
    <div>
      {/* Buy & Win Coupon UI (screen only — excluded from invoice PDF) */}
      {!isLoading && orderData?.coupon_code && (
        <div style={{ ...pageStyle, minHeight: "auto", paddingTop: "32px" }}>
          <BuyWinCouponCard
            order_no={order_no}
            name={name}
            cpr={cpr}
            mob={mob}
            raffleCoupon={raffleCoupon}
            drawDateFormatted={drawDateFormatted}
            promotionFrom={promotionFrom}
            promotionTo={promotionTo}
            couponContent={couponContent}
          />
        </div>
      )}
      {/* Invoice only — used for PDF download (unchanged content) */}
      <div className="invoice-container" id="invoice" ref={printRef} style={{
        maxWidth: '800px',
        margin: 'auto',
        backgroundColor: '#fff',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        fontSize: '18px',
      }}>
        <div className="logo-image" style={{display: 'flex',justifyContent: 'center'}}>
            <img
            src='/old_logo.png'
            alt="Logo"
            style={{width: "15%"}}
            />
        </div>
        <h4 className="invoice-title" style={{textAlign: 'center',marginBottom: '6px'}}>PURCHASE DETAILS</h4>
        <hr/>

        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '10px'}}>
          <tbody>
            <tr>
              <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Order No.</b></th>
              <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Date</b></th>
              <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Status</b></th>
            </tr>
            <tr>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.order_no}</td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{moment(orderData?.createdAt).format("DD-MM-YYYY")}</td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.status}</td>
            </tr>
            <tr>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Buyer's Name</b></td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Buyer's Phone</b></td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Buyer's Area</b></td>
            </tr>
            <tr>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.buyer_first_name}</td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.buyer_mobile}</td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.buyer_area || "N/A"}</td>
            </tr>
            
            <tr>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Promo Code</b></td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Points</b></td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Raffle Coupon</b></td>
            </tr>
            <tr>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.promocode_data?.code}</td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.promocode_data?.points}</td>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.coupon_code}</td>
            </tr>

            <tr>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Draw Date</b></td>
                <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}><b>Draw Prize</b></td>
            </tr>
            <tr>
                <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{moment(orderData?.draw_date).format("DD MMM YYYY")}</td>
                <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{orderData?.draw_prize || "N/A"}</td>
            </tr>

          </tbody>
        </table>

        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '10px'}}>
          <tbody>
              <tr>
                <th colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',textAlign: 'left',color : '#000000ff'}}>
                    <b>Voucher Number</b>
                </th>
                <th colSpan="1" className="text-center" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7',color : '#000000ff'}}>
                    <b>Points</b>
                </th>
                <th colSpan="1" className="text-right" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7', textAlign : 'right',color : '#000000ff'}}>
                    <b>Expiry Date</b>
                </th>
                <th colSpan="1" className="text-right" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#d7c6d7', textAlign : 'right',color : '#000000ff'}}>
                    <b>Status</b>
                </th>
            </tr>
            {orderData?.voucher_number?.length > 0 ? (orderData.voucher_number.map((voucher, index) => (
              <tr key={index}>
                  <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}> {voucher?.voucher_number || "N/A"} </td>
                  <td colSpan="1" className="text-center" style={{border: '1px solid #ddd',padding: '8px'}}> {voucher?.points || "N/A"} </td>
                  <td colSpan="1" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> {moment(voucher?.expiry_date).format('DD-MM-YYYY')} </td>
                  <td colSpan="1" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> {voucher?.status || "N/A"} </td>
              </tr>
            ))) : (
              <tr>
                <td colSpan="2">No vouchers available</td>
              </tr>
            )}           
            
            <tr style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2'}} >
              <td colSpan="7" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left',backgroundColor: '#d7c6d7',color : '#000000ff'}}></td>
            </tr>
              
          </tbody>
        </table>
        <hr/>
      <Loading isLoading={isLoading} text="Please wait for downloading."/>
      <div className="footer" style={{ marginTop: '10px',textAlign: 'center', marginBottom:'-30px' }}>
            <strong>Crown King</strong>
            <p>-- Thank You -- </p>
        </div>
      </div>
    </div>
  );
};

export default DownloadOrder;
